import {api2Endpoint} from 'app/config/apiConfig'
import {queryClient} from 'app/react-query'
import {useMutation} from 'react-query'
import {postData} from '../api/usePostData'
import {announceReturn, announceSend} from '../api/utils/announce'
import errorNotify from '../api/utils/errorNotify'

interface Args {
  route: string
  data: any
  invalidate_key?: any
  noAppendUrl?: boolean
}

export function useOnActionPost<T>(errMsg = 'Error getting data') {
  return useMutation(async (args: Args) => {
    const {data} = args
    try {
      announceSend('post', args.route)
      const route = args?.noAppendUrl ? args.route : api2Endpoint(args.route)
      const retval = await postData<any>(route, data)
      announceReturn('post', args.route)
      args?.invalidate_key && queryClient.invalidateQueries(args.invalidate_key)
      return retval
    } catch (err) {
      errorNotify(err, errMsg)
    }
  })
}
